import * as UpChunk from '@mux/upchunk';
import BaseClient from '../baseClient';

class VideoClient extends BaseClient {
  _generateUploadUrl = async () => {
    throw Error('Video client not initialized!');
  };

  init = (generateUploadUrl) => {
    this._generateUploadUrl = generateUploadUrl;
  };

  _muxUploader = (url, file, onProgress) => {
    return new Promise((resolve, reject) => {
      try {
        // Bridges connection drops of about 30 seconds per chunk. Must stay bounded, a failed
        // upload is discarded and would otherwise block the following messages in the offline queue.
        const upload = UpChunk.createUpload({
          endpoint: url,
          file,
          dynamicChunkSize: true,
          attempts: 10,
          delayBeforeAttempt: 3,
        });

        upload.on('progress', (progress) => {
          const percentage = Math.round(progress.detail);
          onProgress(percentage);
        });

        upload.on('error', (error) => {
          reject(error.detail);
        });

        upload.on('success', () => {
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  upload = async (file, onProgress = () => {}) => {
    const { id: videoId, url } = await this._generateUploadUrl();

    if (!url || !videoId) {
      throw Error('Video upload url could not be generated!');
    }

    await this._muxUploader(url, file, onProgress);

    return videoId;
  };
}

export default new VideoClient();
